import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';

import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';
import config from '@plone/volto/registry';
import { hasBlocksData } from '@plone/volto/helpers/Blocks/Blocks';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

const getDocumentViewClassName = (contentId) => {
  const classes = ['document-view'];
  if (contentId === 'que-oferim') {
    classes.push('que-oferim-page');
  }
  return classes.join(' ');
};

const CSJDefaultView = (props) => {
  const { content, location } = props;
  const contentLoaded =
    content &&
    !(Object.keys(content).length === 1 && Object.hasOwn(content, 'lock'));

  const path = useMemo(
    () => getBaseUrl(location?.pathname || ''),
    [location?.pathname],
  );

  if (!contentLoaded) {
    return null;
  }

  const contentId = content.id;
  const CustomView = contentId
    ? config.settings.contentIdViews?.[contentId]
    : null;

  if (CustomView) {
    return <CustomView {...props} />;
  }

  if (hasBlocksData(content)) {
    const ContainerComponent =
      config.getComponent({ name: 'Container' }).component || Container;
    return (
      <ContainerComponent
        id="page-document"
        className={getDocumentViewClassName(contentId)}
      >
        <RenderBlocks {...props} path={path} />
      </ContainerComponent>
    );
  }

  return <DefaultView {...props} />;
};

CSJDefaultView.propTypes = {
  content: PropTypes.objectOf(PropTypes.any),
  location: PropTypes.objectOf(PropTypes.any),
};

export default CSJDefaultView;
